import {
    apiRequest,
    pemutihanAbsenList,
    pemutihanAbsenActive,
    pemutihanAbsenInactive,
    pemutihanAbsenProcess
} from "../../../../../services/adapters/kepegawaian/pemutihanAbsenService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", pemutihanAbsenList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", pemutihanAbsenInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", pemutihanAbsenActive, {
            body: query
        }, true)
    }

    fetchProcess = async (query) => {
        return await apiRequest("post", pemutihanAbsenProcess, {
            body: query
        }, true)
    }
}

export default DataTableRepository